import { IFilterComplete } from "../filter-complete/filter-complete";

export class InvoicePointSelectManualType implements IFilterComplete {

  constructor(name: string, id: number) {
    this.Name = name;
    this.Id = id;
  }

  public Name: string;
  public Id: number;
}
